var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-import",
    "data-name": "Icon awesome-file-import",
    d: "M.5,9a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5H4V9H.5ZM12.191,0,16,3.809A34.525,34.525,0,0,0,12.191,0ZM11,4.25V0H4.75A.748.748,0,0,0,4,.75V9H8V6.962a.5.5,0,0,1,.856-.353l2.988,3.016a.532.532,0,0,1,0,.75L8.853,13.388A.5.5,0,0,1,8,13.034V11H4v4.25a.748.748,0,0,0,.75.75h10.5a.748.748,0,0,0,.75-.75V5H11.75A.752.752,0,0,1,11,4.25Z",
    transform: "translate(0.5 0.5)",
    fill: "none",
    stroke: "#102250",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExport);
export default __webpack_public_path__ + "static/media/file-export.fa628d83f2d2c1d56f45c7ee928c8460.svg";
export { ForwardRef as ReactComponent };